import React from 'react'

const Admins = () => {
  return (
    <div>Admins</div>
  )
}

export default Admins